import cssVariables from 'tfs.css-variables'

export default {
  checkedInStatus: {
    color: cssVariables.colorWarningBackground,
    fontWeight: 'bold',
  },
}
